export default {
  free: 'GRATIS',
  save: 'Spare {{amount}}',
};
